import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  commandDetailPageResetState,
  getCommandDetailPageData,
  getEventStatusListData,
  sendCommand,
} from "../../store/command-detail-page.store";
import CommandDetailView from "../../views/mobile-frame/command-detail/CommandDetailView";
import { Box, makeStyles } from "@material-ui/core";
import PullToRefresh from "react-simple-pull-to-refresh";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "50px",
  },
}));

const CommandDetailContainer = ({ commandId, eklok }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { token } = useContext(AuthContext);

  const { dataFetched, eventStatusList, error, loading } = useSelector(
    (state) => {
      return state.commandDetailPage;
    },
  );

  const { eklokData, commandList } = useSelector((state) => {
    return state.manualCommandList;
  });

  const command = commandList?.all?.find(
    (item) => item.ACTION_ID === Number(commandId),
  );
  const event = eventStatusList?.find(
    (item) => item.ACTION_ID === Number(commandId),
  );

  console.log("eventStatusList", eventStatusList);
  console.log("event", event);

  const onPlayAndStopButtonPressed = (isPlaying) => {
    dispatch(
      sendCommand({
        token: token,
        eklok: eklok,
        actionId: command?.ACTION_ID,
        actionType: command?.ACTION_TYPE,
        cmd: isPlaying ? "STOP" : "PLAY",
      }),
    );
  };

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(getCommandDetailPageData({ token: token, eklok: eklok }));
      resolve();
    });

  useEffect(() => {
    if (!eklokData || eklokData.id !== eklok) {
      dispatch(getCommandDetailPageData({ token: token, eklok: eklok }));
    } else {
      dispatch(getEventStatusListData({ token: token, eklok: eklok }));
    }
    return () => dispatch(commandDetailPageResetState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading ? <Loading /> : null}
      <Box className={classes.container}>
        {error ? <Error message={{ message: error.message }} /> : null}
        {dataFetched ? (
          <CommandDetailView
            command={command}
            event={event}
            eklokData={eklokData}
            onPlayAndStopButtonPressed={onPlayAndStopButtonPressed}
          />
        ) : null}
      </Box>
    </PullToRefresh>
  );
};

export default CommandDetailContainer;
